import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "condition-button-container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "delete-icon" }

import { ConditionViewModel } from './models/conditionViewModel';
import { IConditionsManager } from './models/conditionsManager';
import ConditionConfigurator from './ConditionConfigurator.vue';
import Icon from '../../icons/Icon.vue';
import { PropType, ref, watch, onBeforeUnmount } from 'vue';
import { IconType } from '@/shared/icons/icons';
import { ConditionPickerOption } from '@shared/components/conditions/models/conditions';
import useVuelidate from '@vuelidate/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionButton',
  props: {
  value: {
    type: Object as PropType<ConditionViewModel>,
    required: true,
  },
  manager: {
    type: Object as PropType<IConditionsManager>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["updated", "deleted", "config-opened", "config-closed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const condition = ref<ConditionViewModel>();
const isOpen = ref(false);
const deleted = ref(false);
const allowClickAway = ref(true);
const $v = useVuelidate();

watch(
  () => props.value,
  (value: ConditionViewModel) => {
    condition.value = value;
    const isActive = condition.value.active || false;
    if (isOpen.value !== isActive) {
      emit(isActive ? 'config-opened' : 'config-closed');
    }
    isOpen.value = isActive;
    checkConditionStillValid();
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  if (!deleted.value && isOpen.value) {
    closeConfig();
  }
});

function getIconComponent(condition: ConditionViewModel): IconType {
  const pickerOption = props.manager.conditions.value.find((c: ConditionPickerOption) => c.id === condition.attribute);
  if (pickerOption && pickerOption.icon) {
    return pickerOption.icon;
  } else if (condition.invalid) {
    return 'ErrorIcon';
  }
  return <IconType>'';
}

function onMouseDownInside() {
  allowClickAway.value = false;
}

function onMouseUpInside() {
  allowClickAway.value = true;
}

function closeConfig() {
  if (allowClickAway.value) {
    checkConditionStillValid();
    emit('updated', condition.value!);
    isOpen.value = false;
    emit('config-closed');
  }

  allowClickAway.value = true;
}

function openConfig() {
  if (props.disabled) {
    return;
  }

  isOpen.value = true;
  emit('config-opened');
}

function updateCondition(update: ConditionViewModel) {
  condition.value = update;
}

function onConfigCompleted(update: ConditionViewModel) {
  condition.value = update;
  closeConfig();
}

function deleteCondition() {
  if (props.disabled) {
    return;
  }

  deleted.value = true;
  emit('deleted');
}

function checkConditionStillValid() {
  if (condition.value) {
    $v.value.$touch();
    const isInvalid = !props.manager.isConditionValid(condition.value) || $v.value.$invalid;

    const currentlyInvalid = !!condition.value.invalid;
    if (isInvalid !== currentlyInvalid) {
      condition.value.invalid = isInvalid;
      emit('updated', condition.value);
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["button condition-button", { 'config-active': isOpen.value, invalid: condition.value?.invalid }]),
      onClick: openConfig,
      disabled: __props.disabled
    }, [
      _createVNode(Icon, {
        icon: getIconComponent(condition.value!)
      }, null, 8, ["icon"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.manager.getFormattedDescription(condition.value!)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          class: "delete is-small",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (deleteCondition()), ["stop"]))
        })
      ])
    ], 10, _hoisted_2),
    _createElementVNode("div", {
      class: "config-wrapper",
      onMousedown: onMouseDownInside,
      onMouseup: onMouseUpInside
    }, [
      (isOpen.value)
        ? _withDirectives((_openBlock(), _createBlock(ConditionConfigurator, {
            key: 0,
            value: condition.value!,
            manager: __props.manager,
            onUpdated: updateCondition,
            onCompleted: onConfigCompleted
          }, null, 8, ["value", "manager"])), [
            [_directive_click_away, closeConfig]
          ])
        : _createCommentVNode("", true)
    ], 32)
  ]))
}
}

})